import { useEffect, useState } from 'react'
import { EuToast, EuToastViewport } from '@newamsterdam/ui'
import { CompanyPickerModal } from './CompanyPickerModal'
import { useCompanyPicker } from '../store/companyPicker'
import { registerCompanyPicker, registerErrorToast } from '../api/client'

interface ErrorToast {
  id: number
  message: string
}

let toastCounter = 0

export function CompanyContextBridge() {
  const openForPending = useCompanyPicker((s) => s.openForPending)
  const [toasts, setToasts] = useState<ErrorToast[]>([])

  useEffect(() => {
    registerCompanyPicker(
      () =>
        new Promise<void>((resolve) => {
          openForPending(resolve)
        }),
    )
    registerErrorToast((message) => {
      toastCounter += 1
      const id = toastCounter
      setToasts((prev) => [...prev, { id, message }])
    })
    return () => {
      registerCompanyPicker(null)
      registerErrorToast(null)
    }
  }, [openForPending])

  function dismiss(id: number) {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }

  return (
    <>
      <CompanyPickerModal />
      <EuToastViewport position="top-right">
        {toasts.map((t) => (
          <EuToast
            key={t.id}
            variant="error"
            title="Niezgodność spółki"
            message={t.message}
            onDismiss={() => dismiss(t.id)}
          />
        ))}
      </EuToastViewport>
    </>
  )
}
